module.exports = __webpack_public_path__ + "static/img/iodine-infused-filter_256.8f40cb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/iodine-infused-filter_256.png
// module id = 1ngw
// module chunks = 0